import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, TextField, Button } from '@mui/material';
import axios from 'axios';
const ReportTable = ({ data ,fetchReports,accessToken}) => {
    const [updatedData, setUpdatedData] = useState(data.map(row => ({ ...row, edited: false })));

    const handleInputChange = (index, value) => {
        const newData = [...updatedData];
        newData[index].item = value;
        newData[index].edited = true;
        setUpdatedData(newData);
    };

    const handleUpdateClick = () => {
        // Filter out only the edited rows
        const editedRows = updatedData.filter(row => row.edited);
    
        // Make a PUT request for each edited row
        editedRows.forEach(row => {
             let config = {
                method: 'put',
                data:{
                    // Assuming your data structure matches the expected format
                    // Adjust this as needed based on your serializer
                    description: row.description,
                    item: row.item,
                    // Add any other fields you want to update
                    
                }, 
                maxBodyLength: Infinity,
                url: `/api/reports/${row.id}/`,
                headers: { 'Authorization': `Bearer ${accessToken}` }
              };
            axios.request(config)
            .then(response => {
                if (response.status === 200) {
                    alert(`${row.description} - ${row.item} updated successfully`);
                    fetchReports()
                } else {
                    // Handle non-successful responses
                    alert(`Failed to update ${row.description} - ${row.item}`);
                }
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                alert(`Network error. Failed to update ${row.description} - ${row.item}`);
            });
        });
    
        // Reset edited state
        setUpdatedData(updatedData.map(row => ({ ...row, edited: false })));
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" className='table table-sm'>
                        <TableHead>
                            <TableRow>
                                <TableCell>DESCRIPTION</TableCell>
                                <TableCell>ITEM</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {updatedData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.description}</TableCell>
                                    <TableCell>
                                        <TextField
                                            value={row.item}
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                            size='small'
                                        />
                                         <Button size='small' className='mx-2' onClick={handleUpdateClick} variant="contained">Update </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                   
                </TableContainer>
               
            </Grid>
        </Grid>
    );
};

export default ReportTable;
